import React from "react";
import { bannerImg } from "../../assests";

const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-end">
      {/* 📱 responsive frame */}
      <div className="relative w-full max-w-[350px] h-auto aspect-[2/1.7]   /* ~350×300 ratio */
                      lgl:max-w-[500px] lgl:aspect-[1/1]">
        {/* gradient background */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#1e2024] to-[#202327] shadow-shadowOne rounded-lg" />

        {/* image fits the box */}
        <img
          src={bannerImg}
          alt="banner"
          className="absolute inset-0 w-full h-full object-contain z-10"
        />
      </div>
    </div>
  );
};

export default RightBanner;
